export default __webpack_public_path__ + "static/media/recreational_fishing_icon.fae9edd2.svg";